import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Avatar, Space, Typography } from 'antd'
import { FC } from 'react'
import { EventParticipation as ParticipationModel } from '../../models/Event'
import { useAppSelector } from '../../store/hooks'
import { selectEventParticipationById } from '../../store/membership/EventParticipationReducer'

const { Text } = Typography

type Props = SBModelComponent<ParticipationModel> & {}

const GuestAvatar: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectEventParticipationById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Space orientation="horizontal">
      <Avatar
        style={{
          color: '#fff',
          backgroundColor: '#8e978a',
          border: 0,
          cursor: 'pointer',
        }}
      >
        <div style={{ textTransform: 'uppercase' }}>
          {item.firstName && item.firstName.slice(0, 1)}
          {item.lastName && item.lastName.slice(0, 1)}
          {!item.firstName && !item.lastName && '--'}
        </div>
      </Avatar>

      <Space.Compact orientation="vertical">
        <Space orientation="horizontal">
          <Text>
            {item.firstName} {item.lastName}
          </Text>
        </Space>
      </Space.Compact>
    </Space>
  )
}

type GuestAvatarType = { GuestAvatar: typeof GuestAvatar }

export { GuestAvatar, type GuestAvatarType }
